import React from 'react';
import { connect } from 'react-redux';
import { intlShape, injectIntl } from 'react-intl';

import { bindActionCreators } from 'redux';
import * as actions from '../actions/process.home.actions';

import AppBar from './navbar/MenuAppBar';
import NavBar from './navbar/ResponsiveBottomNavigation';

class Home extends React.Component {
    render() {
        const { id, title, param, children, noprominent, back, hide } = this.props;

        return (
            <div className="fullscreen flex_full_column">
                <div className="flex_header">
                    <AppBar
                        id={id}
                        title={title}
                        param={param}
                        noprominent={noprominent}
                        back={back || param !== undefined}
                    />
                </div>
                <div className="flex_full_row">
                    <NavBar active={id} hide={hide} />
                    <div
                        className={
                            'display_flex flex_auto overflow_x_scroll ' + (hide ? '' : 'active')
                        }
                    >
                        {children}
                    </div>
                </div>
            </div>
        );
    }
}

Home.propTypes = {
    intl: intlShape.isRequired,
};

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, actions), dispatch);
}

Home = injectIntl(Home);
Home = connect(null, mapDispatchToProps)(Home);

export default Home;



// WEBPACK FOOTER //
// ./src/components/Home.js